import { render, staticRenderFns } from "./Typesetting.vue?vue&type=template&id=28d85134&"
import script from "./Typesetting.vue?vue&type=script&lang=js&"
export * from "./Typesetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports